import { Col, Row } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Category, CategoryId } from 'api/timesheets/categories';
import { Checkbox } from 'components/atoms/checkbox';
import { Categories as CategoriesT } from '../categories';
import { TimesheetSettingTable } from '../components';
import { ControlPanel } from '../control-panel';
import { SetState, State } from '../state';
import { AddCategory } from './add';
import { columns } from './columns';
import { Categories } from './components';
import { Editor } from './editor';
import { useCategoriesSettings } from './use-categories-settings';

const Content = styled.div`
  padding: var(--spacing-05) 0;
`;

interface Props {
  categories: CategoriesT;
  onDelete: (id: CategoryId) => void;
  onAdd: (name: string) => void;
  onUpdate: (category: Category) => void;
  setMandatory: SetState<boolean>;
  categoryMandate: State<boolean>;
}

export const CategoriesSettings: FC<Props> = ({
  categories,
  onDelete,
  onAdd,
  onUpdate,
  categoryMandate,
  setMandatory,
}) => {
  const {
    label,
    description,
    loading,
    data,
    listCaption,
    editing,
    setEditing,
  } = useCategoriesSettings(categories);

  return (
    <ControlPanel label={label} descriptions={[description]}>
      <Row align="middle">
        <Col flex="32px">
          <Checkbox
            value="hello"
            checked={categoryMandate[1]}
            onChange={() => setMandatory(!categoryMandate[1])}
          />
        </Col>
        <Col flex="calc(100% - 32px)">
          <Content>
            <FormattedMessage id="settings.timesheets.controls.categories.mandatory" />
          </Content>
        </Col>
      </Row>
      <AddCategory categories={categories} onAdd={onAdd} />
      <Categories>
        <TimesheetSettingTable
          size="small"
          loading={loading}
          dataSource={data}
          pagination={false}
          columns={columns(data.length, listCaption, setEditing, onDelete)}
        />
      </Categories>
      <Editor editing={editing} setEditing={setEditing} onUpdate={onUpdate} />
    </ControlPanel>
  );
};
